import { byMedia } from '../helpers/media';
export const fullHeight = byMedia(value => value ? `height: 100%;` : '');